import React, { createContext, useContext, useEffect } from 'react';

export type SetFullWidthSlot = (node: React.ReactNode) => void;

export const FullWidthSlotContext = createContext<SetFullWidthSlot | null>(null);

/**
 * Registers React content in the layout’s full-width slot above the max-width column.
 * Clears on unmount. Memoize `content` when it depends on state to avoid redundant updates.
 */
export function useRegisterFullWidthSlot(content: React.ReactNode): void {
  const setSlot = useContext(FullWidthSlotContext);

  useEffect(() => {
    if (!setSlot) return;
    setSlot(content);
    return () => setSlot(null);
  }, [content, setSlot]);
}
